import type { Job, Document } from "@kanda-libs/ks-frontend-services";
import { formatDate } from "common/helpers";

export interface SatNoteTime {
  time: string;
  date: string;
}

export interface FormattedSatNoteData {
  timeline: {
    created: SatNoteTime;
    sent: SatNoteTime;
    viewed: SatNoteTime;
    signed: SatNoteTime;
  };
  questions: {
    advice?: string;
    application?: string;
    availability?: string;
    easiness?: string;
    pressure?: string;
    saving?: string;
  };
  fingerprint?: string;
  certificate?: Document;
}

export const formatSatNoteData = (job?: Job): FormattedSatNoteData => {
  const data = job?.sat_note;
  const timeline = job?.sat_note_timeline;
  const metadata = job?.metadata;

  const times = {
    created: formatDate(metadata?.created_at),
    sent: formatDate(timeline?.sent_at),
    viewed: formatDate(timeline?.viewed_at),
    signed: formatDate(timeline?.signed_at),
  };
  const questions = {
    advice: data?.q_advice,
    application: data?.q_application,
    availability: data?.q_availability,
    easiness: data?.q_easiness,
    pressure: data?.q_pressure,
    ...(data?.q_rate && { rate: data?.q_rate }),
    ...(data?.q_saving && { saving: data?.q_saving }),
  };
  return {
    timeline: times,
    questions,
    fingerprint: data?.signature?.fingerprint,
    certificate: data?.certificate,
  };
};
